// src/fleet-stats/utils/format.js

export function fmtNum(n, digits = 1) {
    return Number(n).toLocaleString(undefined, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    });
}

export function fmtInt(n) {
    return Number(n).toLocaleString();
}

export function fmtPct(ratio, digits = 0) {
    return `${(ratio * 100).toFixed(digits)}%`;
}

export function fmtChangePct(ratio) {
    // ratio = new/old - 1, e.g. -0.34 = down 34%
    const pct = Math.round(Math.abs(ratio) * 100);
    const dir = ratio >= 0 ? "+" : "−";
    return `${dir}${pct}%`;
}

export function fmtDeltaLabel(current, previous) {
    if (!previous || previous === 0) return null;
    return fmtChangePct((current - previous) / previous);
}

export function isSerialName(name) {
    return typeof name === "string" && /^[0-9A-F]{10,}$/i.test(name);
}

// Serial-number robot names are unreadable in lists — show the tail.
export function shortRobotName(name) {
    return isSerialName(name) ? `…${name.slice(-4)}` : name;
}

// Display identity: serial-named robots lead with their site instead of hex.
export function displayRobotName(name, siteName) {
    return isSerialName(name) ? `${siteName || "?"} ${shortRobotName(name)}` : name;
}